import { ArrowsRightLeftIcon } from '@heroicons/react/24/outline';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { AnimatePresence, motion } from 'motion/react';
import { twJoin } from 'tailwind-merge';

import MainButton from '@/components/ui/custom/buttons/MainButton';
import PillComponent from '@/components/ui/custom/dataDisplay/PillComponent';
import Text from '@/components/ui/custom/dataDisplay/Text';
import ConditionalRenderer from '@/components/ui/custom/ConditionalRenderer';
import { accordionX } from '@/utils/animations/commom';
import { ManageScheduledLessonState } from './ManageScheduledLesson';

type AlterDatePillProps = {
  dateTime: Date;
  klassDuration?: number;
  editing?: boolean;
  setModalState?: () => void;
  editPermission?: boolean;
  state?: ManageScheduledLessonState;
};

export function AlterDatePill({
  dateTime,
  klassDuration,
  editing,
  setModalState,
  editPermission,
  state = 'manager',
}: AlterDatePillProps) {
  const { t } = useTranslation('translation', {
    keyPrefix: 'calendar.admin.manageKlass',
  });

  return (
    <PillComponent
      testId="alterDate"
      className={twJoin(
        'w-fit flex-wrap',
        state === 'manager' ? '' : 'px-2 py-1',
      )}
    >
      <Text
        text={moment(dateTime).format('DD/MM')}
        format="poppins-600"
        className="text-primary h-fit flex self-center text-[0.875rem] xl:text-[1rem]"
      />
      <Text
        text={`${moment(dateTime).format('HH:mm')}-${moment(dateTime)
          .add(klassDuration || 90, 'minutes')
          .format('HH:mm')}`}
        className="text-base-content h-fit ml-2 text-[0.875rem] xl:text-[1rem] shrink-0"
      />
      <ConditionalRenderer condition={editPermission}>
        <AnimatePresence>
          <motion.div {...accordionX(editing)} className="overflow-hidden">
            <MainButton
              dataTestId="alterLessonDateButton"
              icon={<ArrowsRightLeftIcon />}
              color="custom"
              className="text-primary gap-1 ml-2 whitespace-nowrap text-[0.875rem] xl:text-[1rem]"
              onClick={setModalState}
              text={t('alterLessonDate')}
            />
          </motion.div>
        </AnimatePresence>
      </ConditionalRenderer>
    </PillComponent>
  );
}
